import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/settings.svg'


const _withScopeId = n => (_pushScopeId("data-v-2c4f2490"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "header-menu",
  class: "full-height"
}
const _hoisted_2 = {
  id: "welcome_message",
  class: "body_text"
}
const _hoisted_3 = { class: "btn-group" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn dropdown-toggle",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "icon",
    alt: "settings",
    src: _imports_0
  })
], -1))
const _hoisted_5 = { class: "dropdown-menu" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" })
], -1))
const _hoisted_8 = { class: "grey" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChangePasswordModal = _resolveComponent("ChangePasswordModal")!
  const _component_HelpModal = _resolveComponent("HelpModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("HEADER.HELLO")) + " " + _toDisplayString(_ctx.username) + "! ", 1),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "dropdown-item",
                onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.openModal(); _ctx.$emit('openModalEmit')})
              }, _toDisplayString(_ctx.$t("HEADER.CHANGE_PASSWORD")), 1)
            ]),
            (_ctx.portalMessages == true)
              ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openMessagesPage()))
                  }, _toDisplayString(_ctx.$t("HEADER.CONTACT")), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "dropdown-item",
                onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.openHelpModal(); _ctx.$emit('openHelpEmit')})
              }, _toDisplayString(_ctx.$t("HEADER.HELP.TITLE")), 1)
            ]),
            _hoisted_7,
            _createElementVNode("li", _hoisted_8, [
              _createElementVNode("a", {
                class: "dropdown-item",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.logout()))
              }, _toDisplayString(_ctx.$t("HEADER.LOGOUT")), 1)
            ])
          ])
        ])
      ])
    ]),
    (_ctx.showModal)
      ? (_openBlock(), _createBlock(_component_ChangePasswordModal, {
          key: 0,
          showModal: _ctx.showModal,
          onClicked: _ctx.onChildClick
        }, null, 8, ["showModal", "onClicked"]))
      : _createCommentVNode("", true),
    (_ctx.showHelpModal)
      ? (_openBlock(), _createBlock(_component_HelpModal, {
          key: 1,
          showHelpModal: _ctx.showHelpModal,
          onClicked: _ctx.onChildClick
        }, null, 8, ["showHelpModal", "onClicked"]))
      : _createCommentVNode("", true)
  ], 64))
}